import React, { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../reactcontext/ReactContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AddProfile from "./form/AddProfile";
import ProfileTableInit from "./tables/ProfileTableInit";
import ProfileDetails from "./ProfileDetails";
import ProfilePayment from "../Payment/ProfilePayment";
import axios from "axios";

const Landing = () => {
  const [selectedProfile, setSelectedProfile] = useState({});
  const [showSecondTab, setShowSecondTab] = useState(false);
  const { loginInfo } = useContext(LoginContext);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const agentData = searchParams.get("agentData");
  const parsedAgentData = agentData ? JSON.parse(agentData) : null;
  const initialStatusFilter = searchParams.get("status") || "All";
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [userPermissions, setUserPermissions] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    !loginInfo.login && navigate("/profile");
    fetchUserPermissions();
  }, [loginInfo]);

  const fetchUserPermissions = async () => {
    try {
      setIsAdmin(loginInfo.userDetails?.role?.toLowerCase() === 'admin');
      const response = await axios.get(`${apiUrl}/permission/user`, {
        headers: { loginToken: localStorage.getItem('loginToken') }
      });
      setUserPermissions(response.data.permissions || []);
    } catch (error) {
      console.error('Error fetching user permissions:', error);
    }
  };

  const hasPermission = (permissionName) => {
    if (isAdmin) return true;
    return userPermissions.some(perm => perm.name === permissionName);
  };

  //const [agentId, setAgentId] = useState(parsedAgentData.id)

  const refreshTable = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // Define tab content
  const tabContent = [
    {
      title: "Add Employee",
      content: <AddProfile setActiveTab={setActiveTab} />,
    },
    { title: 'Lists Profiles', content: <ProfileTableInit setActiveTab={setActiveTab} setSelectedProfile={setSelectedProfile} refreshTrigger={refreshTrigger} initialStatusFilter={initialStatusFilter}/> },
    { title: 'Profile Info', content: <ProfileDetails
                                          setActiveTab={setActiveTab}
                                          profile={selectedProfile}
                                          setSelectedProfile={setSelectedProfile}
                                          refreshTable={refreshTable}
                                        />

    },
    //{ title: '', content: <ProfilePayment agentId={agentId} profile={selectedProfile} setActiveTab={setActiveTab} activeTab={activeTab}/> },
  ];

  useEffect(() => {
    !loginInfo.login && navigate("/profile");
  }, [loginInfo]);

  // Handle tab change
  const handleTabChange = (index) => {
    setActiveTab(index);
    setShowSecondTab(!showSecondTab);
  };

  return (
    <div className="w-full bg-gray-50 flex h-full flex-col relative">
      {/* Header bar */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white shadow-sm">
        <div className="text-sm text-gray-600">
          <Link to={"/dashboard"} className="text-yellow-700 hover:underline">
            Dashboard
          </Link>
          {" > "}
          <span className="font-semibold text-gray-800">Employee</span>
        </div>
        <div className="flex items-center gap-2">
          {tabContent.map((tab, index) => (
            <React.Fragment key={index}>
              {(
                (index === 0 && !showSecondTab && (isAdmin || hasPermission('employees.create'))) ||
                (index === 1 && showSecondTab) ||
                (index === 2 && showSecondTab)
              ) ? (
                <button
                  onClick={() => handleTabChange(index)}
                  className={
                    activeTab === index
                      ? "border border-gray-400 bg-gray-200 text-gray-800 text-sm font-semibold px-4 py-2 rounded-lg"
                      : "border border-gray-300 bg-white text-gray-700 text-sm font-medium px-4 py-2 rounded-lg hover:bg-gray-50 shadow-sm"
                  }
                >
                  {tab.title}
                </button>
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="w-full flex-1 overflow-auto">
        {tabContent[activeTab].content}
      </div>
    </div>
  );
};

export default Landing;
